import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Headline from './headline';
import TumourShot from './tumourShot';
import TumourSpeak from './tumourSpeak';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {

    useEffect(() => {
        document.querySelector('#root').style.backgroundImage = `url(${content.pageConfig.pageBackground})`;
        document.body.style.backgroundColor = content.pageConfig.pageColor;
    }, []);

    const headlineData = {
        bigSildesData: content.bigSildesData,
        sideTextData: content.sideTextData,
        pageConfig: content.pageConfig
    };
    const tumourSpeakData = {
        smallSildesData: content.smallSildesData,
        tumourSpeakData: content.tumourSpeakData,
        title: content?.pageConfig?.headTitle3,
        mouldeBigImage: content?.pageConfig?.mouldeBigImage,
        
    };
    const tumourShotData = {
        tumourShotList: content.tumourShotData,
        title: content?.pageConfig?.headTitle2,
        mouldeBigImage: content?.pageConfig?.mouldeBigImage,
    };

    return (
        <div className={styles.layout_body} id="layoutBody">
            <Headline content={headlineData} />
            {content.tumourShotData && content.tumourShotData.length > 0 &&
                <Chip
                    id="285828"
                    type="recommend"
                    title="大咖访谈"
                    groupName="预防肿瘤"
                    content={tumourShotData}
                >
                    <TumourShot />
                </Chip>}
            <TumourSpeak content={tumourSpeakData} />
            <Chip
                id="260205"
                type="struct"
                title="页面配置"
                groupName="预防肿瘤"
                content={content.pageConfig}
            >
                <div className={styles.content_list}>
                    <div className={styles.chip_item} />
                </div>
            </Chip>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
